import { render, staticRenderFns } from "./MapSettings.vue?vue&type=template&id=8706429a&scoped=true&"
import script from "./MapSettings.vue?vue&type=script&lang=js&"
export * from "./MapSettings.vue?vue&type=script&lang=js&"
import style0 from "./MapSettings.vue?vue&type=style&index=0&id=8706429a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8706429a",
  null
  
)

export default component.exports